import { useState, useEffect, useRef } from 'react';

export const useInViewport: (
  target: React.RefObject<Element>,
  options?: IntersectionObserverInit,
) => boolean = (
  target,
  options = {},
) => {
  const [isInViewport, setIsInViewport] = useState(false);
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observer.current?.disconnect();

    if (target.current) {
      const _observer = new IntersectionObserver(entries => {
        setIsInViewport(entries[0].isIntersecting);
      }, options);
      _observer.observe(target.current);
      observer.current = _observer;
    }

    return () => {
      observer.current?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target.current, options.root, options.rootMargin, options.threshold]);

  return isInViewport;
};
